import * as constants from "./revisionConstants";

const initialState = {
  allRevisionStatuses: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const revisionStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_REVISION_STATUSES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_REVISION_STATUSES_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allRevisionStatuses: [...state.allRevisionStatuses, action.data],
        isAdding: false,
      };
    case constants.CREATE_REVISION_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_ORDER_REVISION_STATUS:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.UPDATE_ORDER_REVISION_STATUS_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allRevisionStatuses: action.data,
      };
    case constants.UPDATE_ORDER_REVISION_STATUS_ERROR:
      return {
        ...state,
        fetchingLoading: false,
      };

    case constants.FETCH_REVISION_STATUSES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_REVISION_STATUSES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allRevisionStatuses: action.data,
        isAdding: false,
      };
    case constants.FETCH_REVISION_STATUSES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_REVISION_STATUSES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_REVISION_STATUSES_SUCCESS:
      const updated = state.allRevisionStatuses.map((el) =>
        el.id === action.data.id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allRevisionStatuses: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_REVISION_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_REVISION_STATUSES:
      return {
        ...state,
        updateLoading: true,
        isAdding: false,
      };
    case constants.DELETE_REVISION_STATUSES_SUCCESS:
      const updatedData = state.allRevisionStatuses.filter(
        (el) => el.id !== action.data
      );
      return {
        ...state,
        allRevisionStatuses: updatedData,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_REVISION_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default revisionStatusReducer;
